import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "help-sheet",
  role: "dialog",
  "aria-label": "Help"
}
const _hoisted_2 = { class: "sheet-head" }
const _hoisted_3 = { class: "sheet-title" }
const _hoisted_4 = { class: "sheet-body" }
const _hoisted_5 = {
  key: 0,
  class: "sheet-state"
}
const _hoisted_6 = {
  key: 1,
  class: "sheet-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocContent = _resolveComponent("DocContent")!

  return (_openBlock(), _createBlock(_Transition, { name: "sheet" }, {
    default: _withCtx(() => [
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "help-backdrop",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "sheet-handle" }, null, -1)),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.doc ? _ctx.doc.title : 'Help'), 1),
                _createElementVNode("button", {
                  class: "sheet-close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                  "aria-label": "Close help"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Loading guide..."))
                  : (!_ctx.doc)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, " This guide could not be loaded. Connect to the internet and try again. "))
                    : (_openBlock(), _createBlock(_component_DocContent, {
                        key: 2,
                        doc: _ctx.doc,
                        anchor: _ctx.anchor,
                        offline: _ctx.offline,
                        "updated-note": _ctx.updatedNote
                      }, null, 8, ["doc", "anchor", "offline", "updated-note"]))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}